export default __webpack_public_path__ + "static/media/EMprint Light.874befd5.svg";